const es = {  
    helmet_index_description : 'Descubre las zonas de picnic que hay a tu alrededor',
    home: 'Zonas',
    ajustes: 'Añade zonas',
    home_cerca: 'Cerca de mí',
    menu_listado: 'Listado',
    menu_mapa: 'Mapa',
    detalles_aseos: 'Aseos',
    detalles_aseos_descripcion: 'Si hay lavabos en la zona',
    detalles_banyo: 'Zona Baño',
    detalles_banyo_descripcion: 'Lago, piscina, playa,...',
    detalles_zona_infantil: 'Zona Infantil',
    detalles_zona_infantil_descripcion: 'Parque, columpios, toboganes, ...',
    detalles_mesas: 'Mesas',
    detalles_mesas_descripcion: 'Si hay mesas en la zona',
    detalles_alimentacion: 'Alimentación',
    detalles_alimentacion_descripcion: 'Bar, restaurante, kiosko,...',
    add_zonas_title: '¿Quieres añadir más zonas?',
    add_zonas_1: 'Haz click ',
    add_zonas_2: 'aquí',
    add_zonas_3: 'y rellena el formulario',
    add_zonas_4: 'Gracias. Otros usuarios disfrutarán de tu aportación.',
    add_zona: 'Añadir zona',
    add_zona_descripcion: 'Completa los campos y añade la zona al mapa.\nGracias. Otros usuarios disfrutarán de tu aportación.',
    nueva_zona_nombre: 'Nombre',
    nueva_zona_descripcion: 'Descripción',
    nueva_zona_ciudad: 'Ciudad',
    nueva_zona_pais: 'País',
    nueva_zona_zona_banyo: '¿Tiene zona de baño?',
    nueva_zona_bar: '¿Tiene algún bar o restaurante?',
    nueva_zona_zona_infantil: '¿Tiene zona infantil?',
    nueva_zona_aseos: '¿Cuántos aseos tiene?',
    nueva_zona_mesas: '¿Cuántas mesas tiene?',
    nueva_zona_fuentes: '¿Cuántas fuentes de agua tiene?',
    nueva_zona_barbacoa: '¿Dispone de zona de barbacoa?',
    nueva_zona_tipo_suelo: '¿Que tipo de suelo hay en su mayoría?',
    nueva_zona_url_imagen: 'Añade un link de una imagen',
    nueva_zona_add_btn : "Añadir zona",
    si : "Si",
    no : "No",
    cesped : "césped",
    tierra : "tierra",
    piedras : "piedras",
    arena : "arena",
    asfalto : "asfalto",
    nueva_zona_error_titulo: "Atención",
    nueva_zona_error_nombre: "Debe introducir un nombre",
    nueva_zona_error_ciudad: "Debe introducir el nombre de una ciudad",
    nueva_zona_error_país: "Debe introducir el nombre de un país",
    nueva_zona_error_aseos: "Debe introducir un número valido en la cantidad de aseos",
    nueva_zona_error_fuentes: "Debe introducir un número valido en la cantidad de fuentes",
    nueva_zona_error_mesas: "Debe introducir un número valido en la cantidad de mesas",
    nueva_zona_creada: "Zona creada correctamente 👍🏽",
    info_zona_error_descripcion: "Deja claro el error que describes e intenta aportar la solución.\nSi el error es la posición, la cantidad de mesas, ..., envianos el dato correcto.\nMuchas gracias.",
    info_zona_error_titulo: "Comunicar un error",
    info_zona_error_boton: "Enviar",
    info_zona_error_placeholder: "Escribe aquí la descripción del error",
    info_zona_error_enviado: "Se ha enviado correctamente. Gracias",
    info_zona_error_error: "Por favor, introduce una descripción para el error.",
    bienvenida_texto: "Si conoces alguna zona que no ves en el mapa, sólo tienes que mantener pulsado sobre el punto del mapa dónde esta esa zona y se te abrirá un formulario para rellenar los datos. Cuando lo envies se mostrará la nueva zona en el mapa.\n\n"+
    "En el detalle de una zona, puedes pulsar sobre el mapa para abrir google maps con las indicaciones para llegar a la zona o al megafono para reportar algún error en la zona mostrada.\n\n"+
    "Con esta app podrás localizar las zonas de picnic que tengas a tu alrededor.\n"+
    "También puedes ayudar a añadir más y que todos podamos disfrutar de todas las zonas de picnic.",
    bienvenida_cerrar : "Cerrar",
    bienvenida_no_mostrar : "No volver a mostrar",
    change_detail_image_descripcion: "Escribe la URL de la imagen que quieras enviar",
    change_detail_image_boton: "Enviar url",
    change_detail_imageplaceholder: "Escribe aquí la Url",
    change_detail_image_titulo: "Imagen recibida",
    change_detail_image_enviado: "Se ha añadido la imagen de la zona. Gracias.",
    change_detail_image_error_titulo: "Atención",
    change_detail_image_error: "Por favor, introduce la url de la imagen.",
    change_detail_image_foto: "Sube una nueva foto",
    change_detail_image_foto_error: "Se ha producido un error al coger la foto.\nRevise los permisos de la app.",
    select_language: "Selecciona la lengua",
    btn_ok: "OK",
    title_detalle: "Detalle",
    translate_to: "Traducir a Español",
    share_title: "Comparte la zona",
    share_text: "Mira esta area de picnic",
    share_thanks: "Gracias por compartir el area",
    share_copied_to_clipboard: "Se ha copiado la url al portapapeles",
    error_location_denied: "Si quieres utilizar la ubicación debes activarlo en los ajustes",
    error_location: "Error en la localización del usuario"
  };
  export default es;